export default {"src":"/evde-internet/_next/static/media/tebrik.2a8024e0.svg","height":96,"width":96};